"use client";

import Image from "next/image";
import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { motion } from "framer-motion";

const SapaUmkm = () => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const dataDummy = [
    {
      title: "Integrasi Program",
      color: "cust-blue",
      subtitles: [
        {
          subtitle: "Pembiayaan",
        },
        {
          subtitle: "Inkubator Progress",
        },
        {
          subtitle: "UMKM Data Mart (Business Intelligence)",
        },
        {
          subtitle: "UMKM Warrior (Gamification)",
        },
        {
          subtitle: "UMKM Community",
        },
        {
          subtitle: "UMKM Artficial Intelligence",
        },
      ],
    },
    {
      title: "Integrasi Data",
      color: "cust-orange",
      subtitles: [
        {
          subtitle: "Data UMKM",
        },
        {
          subtitle: "Data Transaction",
        },
        {
          subtitle: "Event",
        },
        {
          subtitle: "News",
        },
        {
          subtitle: "Survei",
        },
        {
          subtitle: "Online Consulting",
        },
      ],
    },
  ];

  return (
    <div className="flex justify-center items-center px-5 sm:px-10 md:px-16 pb-7 sm:pb-12 md:pb-20 text-white overflow-hidden">
      <motion.div
        className='flex flex-col justify-center items-center gap-4 sm:gap-7 md:gap-10 bg-[url("/image/bg-sapa-umkm-arah-kebijakan.webp")] bg-cover bg-center bg-no-repeat px-8 sm:px-12 md:px-20 pt-7 sm:pt-12 md:pt-20 pb-10 rounded-4xl md:rounded-[60px]'
        initial={{ opacity: 0 }}
        whileInView={{
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
          ease: "easeInOut",
        }}
        viewport={{ once: true }}
      >
        <div className="flex flex-col justify-center items-center gap-4">
          <motion.div
            className="w-full font-bold text-4xl md:text-5xl text-center md:text-left"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              delay: 1.25,
              ease: "easeInOut",
            }}
            viewport={{ once: true }}
          >
            SAPA UMKM
          </motion.div>
          <motion.div
            className="w-full font-normal text-xl sm:text-2xl md:text-3xl"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{
              x: 0,
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              delay: 1.5,
              ease: "easeInOut",
            }}
            viewport={{ once: true }}
          >
            Sebagai Upaya Penguatan Sinergi Pusat-Daerah dan Rekomendasi
            Kebijakan dalam Pemberdayaan UMKM dan Kewirausahaan
          </motion.div>
        </div>
        <motion.div
          className="w-full font-light text-base md:text-lg"
          initial={{ x: 50, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            delay: 1.75,
            ease: "easeInOut",
          }}
          viewport={{ once: true }}
        >
          Dirancang sebagai Super Ekosistem yang dapat mengkonsolidasikan
          seluruh program pemberdayaan UMKM dan Kewirausahaan yang terintegrasi
          baik di Pemerintah Pusat dan Daerah, BUMN, BUMD maupun Swasta untuk
          menghindari terjadinya tumpang tindih program.
        </motion.div>
        <div className="flex flex-col md:flex-row justify-center items-center w-full gap-7 sm:gap-12 md:gap-20">
          <motion.div
            className="relative flex justify-center items-center w-full md:w-2/3 h-80 md:h-[32rem]"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              delay: 2,
              ease: "easeInOut",
            }}
            viewport={{ once: true }}
          >
            <Image
              className="object-contain"
              src="/image/Sapa_UMKM_Mockup.webp"
              alt="iPhone App Preview"
              fill
            />
          </motion.div>
          <motion.div
            className="w-72 sm:w-[500px] md:w-1/3"
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              delay: 2,
              ease: "easeInOut",
            }}
            viewport={{ once: true }}
          >
            <Swiper
              modules={[Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              pagination={false}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
              className="w-full"
            >
              {dataDummy.map((data, idx) => (
                <SwiperSlide key={idx}>
                  <div className="flex flex-col justify-center items-center gap-5 w-full">
                    <div className="w-full font-bold text-3xl text-center md:text-left">
                      {data.title}
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2 w-full">
                      {data.subtitles.map((text, index) => (
                        <div
                          key={index}
                          className="flex flex-row justify-center items-center gap-2 w-full px-4 py-3 rounded-xl"
                          style={{
                            backgroundImage:
                              "linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(221,221,221,0.3) 60%, rgba(239,239,239,0.6) 100%)",
                          }}
                        >
                          <div
                            className={`flex justify-center items-center font-medium text-2xl text-white bg-${data.color} w-9 h-9 rounded-full`}
                          >
                            {index + 1}
                          </div>
                          <div className="flex justify-start items-center w-full text-lg font-medium">
                            {text.subtitle}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex justify-center items-center gap-2 mt-10 md:mt-6">
              {dataDummy.map((_, idx) => (
                <div
                  key={idx}
                  className={`w-3 h-3 rounded-full cursor-pointer transition-all duration-300 ${
                    activeIndex === idx ? "bg-cust-orange" : "bg-white"
                  }`}
                  onClick={() => swiperRef.current?.slideTo(idx)}
                />
              ))}
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default SapaUmkm;
